import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

export const Entertainment = () => {
  const { t } = useLanguage();
  return (
    <section id="entertainment" data-testid="entertainment-section" className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <h3 data-testid="booking-ent-title" className="font-serif text-3xl sm:text-5xl text-ivory tracking-tight leading-[1.1]">{t.booking.entTitle}</h3>
          <p data-testid="booking-ent-intro" className="mt-6 max-w-3xl text-ash font-light leading-relaxed">{t.booking.entIntro}</p>
          <div className="gc-gold-line mt-8 w-24 bg-gold/60" />
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 gap-px bg-ivory/10 border border-ivory/10">
          {t.booking.categories.map((cat, i) => (
            <Reveal key={cat.title} delay={(i % 2) * 0.08} className="h-full">
              <div
                data-testid={`booking-category-${i}`}
                className="h-full bg-ink p-8 hover:bg-raised transition-colors duration-300"
              >
                <h4 className="font-serif text-xl text-champagne">{cat.title}</h4>
                <p className="mt-3 text-sm text-ash font-light leading-relaxed">{cat.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <p data-testid="booking-closing" className="font-serif italic text-xl sm:text-2xl text-champagne/90">{t.booking.closing}</p>
        </Reveal>

        <Reveal className="mt-10">
          <button
            data-testid="booking-cta"
            onClick={() => scrollToId("contact")}
            className="flex items-center gap-3 px-8 py-3.5 bg-gold text-ivory text-[11px] tracking-[0.25em] uppercase font-semibold hover:bg-champagne hover:text-ink transition-colors duration-300"
          >
            {t.booking.cta}
            <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
